import { updateIndustryApi } from "@/api/services/admin/learning-content";
import { TUpdateIndustryReqDto } from "@/api/services/admin/learning-content/dtos/update-industry.dto";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { EIndustryExamType } from "@/types/enum";
import { showError } from "@/utils/error";
import { toast } from "@/utils/toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type TUpdateMemoParams = {
  name: string;
  examType: EIndustryExamType;
  memo: string;
};

/**
 * Hook to update only the internalMemo field of an industry.
 * Designed for blur-to-save on the detail page's 社内メモ field.
 * Requires `name` and `examType` because the update API mandates them.
 */
export const useUpdateIndustryMemo = (industryId?: string) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ name, examType, memo }: TUpdateMemoParams) => {
      if (!industryId) return Promise.reject(new Error("Missing industryId"));
      const payload: TUpdateIndustryReqDto = { name, examType, internalMemo: memo || null };
      return updateIndustryApi(industryId, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.LEARNING_CONTENT.FETCH_DETAIL, industryId] });
      toast.success(API_SUCCESS_MESSAGE);
    },
    onError: (error) => {
      showError(error);
    },
  });

  return mutation;
};
